import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgencyService } from 'src/app/core/_services/agency.service';
import { AuthService } from 'src/app/core/_services/auth.service';
import { Agency } from 'src/app/core/_models/agency';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { AppState } from 'src/app/store/app.state';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UpdateResourceAction } from 'src/app/store/actions/resource.actions';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { MatDialog } from '@angular/material/dialog';
import { FunctionalityCode } from 'src/app/core/_enums/functionality.code';

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.scss']
})
export class AgencyComponent implements OnInit {
  currentItem: Agency = {};
  form!: FormGroup;
  perimeterId!: string;
  manageAgency!: boolean;
  rdfAdherent = false;

  constructor(
    private agencyService: AgencyService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private snackbarService: SnackbarService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.form = this.formBuilder.group({
      agencyId: [],
      code: ['', Validators.required],
      displayName: ['', Validators.required],
      address_L3: [''],
      address_L4: [''],
      address_L5: [''],
      address_Location: [''],
      address_PC: [],
      parent: [{ value: '', disabled: true }],
      euId: []
    });
  }

  ngDoCheck(): void {
    if (this.authService?.accessesValues) this.manageAgency = this.authService.accessesValues.includes(FunctionalityCode.ManageAgency);
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      this.perimeterId = history.state?.perimeterId;

      if (history.state?.agencyId) {
        this.agencyService.get(params?.id).subscribe((agency) => {
          this.form.patchValue(agency);
          this.currentItem = agency;
          this.rdfAdherent = !!agency.isRdfAdherent;
        });
      } else {
        this.form.patchValue({
          euId: this.perimeterId,
          parent: this.getParentName()
        });
      }
    });
  }

  get formCrls() {
    return this.form.controls;
  }

  openDialogDelete(agencyId: string): void {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_agency') }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.delete(agencyId);
      }
    });
  }

  delete(agencyId: string) {
    if (agencyId) {
      this.agencyService.delete(agencyId).subscribe({
        next: () => {
          this.majStore(SnackbarTypes.delete);
          this.router.navigate([SiteMapUrl.MenuOrganisation]);
        },
        error: (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          console.error(error);
        }
      });
    }
  }

  getParentName() {
    return this.authService.roleValue.perimeterName;
  }

  userHasManageRights() {
    let hasRights;
    this.authService.getAccesses(this.authService.roleValue.profileCode).subscribe((list) => {
      hasRights = list.includes(FunctionalityCode.ManageAgency);
    });
    return hasRights;
  }

  async clickSave(agency: Agency) {
    if (this.form.invalid) {
      return;
    }

    // INSERT
    if (!this.formCrls?.agencyId?.value) {
      delete agency.agencyId;
      let rep = await this.agencyService.add(agency);
      rep.subscribe(
        () => {
          this.majStore(SnackbarTypes.add);
        },
        (error) => {
          this.snackbarService.open(SnackbarTypes.error);
        }
      );
    }
    // UPDATE
    else {
      let rep = await this.agencyService.update(agency);
      rep.subscribe(
        () => {
          this.majStore(SnackbarTypes.update);
        },
        (error) => {
          this.snackbarService.open(SnackbarTypes.error);
        }
      );
    }
  }

  majStore(snackbarMsgType: string) {
    this.agencyService.getAll().subscribe(
      (arr) => {
        if (arr) {
          this.store.dispatch(new UpdateResourceAction(arr));
          this.snackbarService.open(snackbarMsgType);
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    );
  }
}
